<template>

    <div class="chart-dog">
        <tool-container>
            <template v-slot:tabs>
                <b-tab title="Compose">
                    <tool-container-compose-toolbar>
                    </tool-container-compose-toolbar>

                    <chart-dog-step1 v-if="onStep(1)">
                    </chart-dog-step1>

                    <chart-dog-step2 v-if="onStep(2)">
                    </chart-dog-step2>

                    <chart-dog-step3 v-if="onStep(3)">
                    </chart-dog-step3>

                    <chart-dog-step4 v-if="onStep(4)">
                    </chart-dog-step4>
                </b-tab>

                <b-tab title="Preview">
                    <tool-container-preview-toolbar>
                    </tool-container-preview-toolbar>

                    <chart-dog-preview>
                    </chart-dog-preview>
                </b-tab>
            </template>
        </tool-container>
    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import ChartDogMixin from "@/providers/ChartDogMixin"

    export default Vue.extend({
        name: "ChartDog",
        mixins: [ToolMixin, ChartDogMixin],
    })

</script>

<style lang="scss">

    .chartdog-container {
        /* overflow:hidden;   This rule isn't necessary  */
        min-height: 550px;
    }

    @media (min-width: 1024px) {
        /* .chartdog-container {padding-top:1em;} */
    }

    highchart {
        display: unset;
        width: 700px;
        max-width: 700px;
    }

    .color-chip {
        display: inline-block;
        width: 24px;
        height: 16px;
        border-radius: 3px;
        margin-left: 10px;
    }

    button .color-chip {
        margin-right: 5px;
    }

    .marker-icon {
        display: inline-block;
        width: 24px;
        height: 16px;
        border-radius: 3px;
        margin-left: 10px;
    }

    button .marker-icon {
        margin-right: 5px;
    }

    li.color-selector, li.marker-selector {
        cursor: pointer;
    }

    button.color-selector, button.marker-selector {
        color: #333;
    }

    .phase-1 {
        background-color: #c8ff9b;
    }

    .phase-2 {
        background-color: #ffc89b;
    }

    .phase-3 {
        background-color: #ffff9b;
    }

    .phase-4 {
        background-color: #ffc8ff;
    }

    .color-selector-Red .color-chip {
        background-color: #c73865;
    }

    .color-selector-Blue .color-chip {
        background-color: #005b89;
    }

    .color-selector-Green .color-chip {
        background-color: #628C11;
    }

    .color-selector-Purple .color-chip {
        background-color: #B0407D;
    }

    .color-selector-Orange .color-chip {
        background-color: #ea8e12;
    }

    .color-selector-Yellow .color-chip {
        background-color: #8F6B00;
    }

    .color-selector-Pumpkin .color-chip {
        background-color: #8F2900;
    }

    .color-selector-Indigo .color-chip {
        background-color: #171780;
    }

    .nav-tabs {
        border-bottom: none;
    }

    .nav-tabs > li {
    }

    .nav-tabs > li.active {
        z-index: 10;
    }

    .nav-tabs > li > a {
        cursor: pointer;
        border: none;
    }

    .nav-tabs > li.active > a {
        border-top: solid 1px #fff !important;
        border-left: solid 1px #fff !important;
        border-right: solid 1px #fff !important;
        z-index: 10;
    }

    .nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {
        background-color: #FAF6F2;
        border: none;
        /* color:#fff; */
    }

    .nav-tabs > li > a:hover {
        background-color: #FAF6F2;
    }

    .nav-tabs-content {
        background-color: #FAF6F2;
        padding: 20px 10px 10px;
    }

    .phase-data-list {
        background-color: #FAF6F2;
        margin-top: -20px; /* ?? */
        margin-bottom: 10px;
        padding: 0 10px;
    }

    .phase-data-list button.add-point {
        margin-top: 10px;
    }

    .phase-data-list .alert.duplicate-date {
        padding: 5px 15px;
        margin: 5px 0 10px 0;
    }

    .phase-dates {
        font-size: .8em;
        color: #999;
    }

    input.point-date {
        width: 160px !important;
        display: inline-block;
    }

    input.point-value {
        width: 75px !important;
        display: inline-block;
    }

    chartdog #step-2 .data-form-row {
        margin: 5px 0;
    }

    chartdog #step-2 .input-group {
        margin: 0;
    }

    table.table.no-borders td,
    table.table.no-borders th {
        border-top: none;
    }

    textarea.comments {
        min-height: 200px;
    }

    td.data-analysis {
        min-width: 200px;
    }

    .no-data {
        /*font-style: italic;*/
    }

</style>
